import { getMainPagePath } from '@utils/generalUtils';

export const setFloorPathForFloorView = (floorId: string, history: any) => {
	const path: string = getMainPagePath(floorId);
	history.push(path);
};
